export enum INVITATION_TYPES {
  AUDITION = 'AUDITION',
  CALLBACK = 'CALLBACK',
}
